import SvgIcon from '../svg/SvgIcon'

export default ({
  titleBarOnClick,
  titleBarStyle = {},
  titleText = '',
  enableCloseIcon = true,
  svgIcons,
  closeIconAdditionalClass = '',
  onCloseIconClick,
}) =>
  <div
    className="title-bar"
    onClick={titleBarOnClick}
    style={titleBarStyle}
  >
    <div className="title-bar-title">{titleText.toUpperCase()}</div>
    {enableCloseIcon &&
      <SvgIcon
        svgIcons={svgIcons}
        iconName="close"
        additionalClass={closeIconAdditionalClass}
        onClick={onCloseIconClick}
        eventsOnContainer={true}
      />}
  </div>